import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotFound = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 152,
	height: 148,
	viewBox: "0 0 152 148",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			className: "bgCircle",
			cx: 76,
			cy: 64.7996,
			rx: 55.2,
			ry: 55.2,
			fill: "#5C65A3"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "dot",
			cx: 12,
			cy: 16.0004,
			r: 5.6,
			fill: "#4051BF"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			className: "dot",
			cx: 8.40005,
			cy: 112.401,
			rx: 7.6,
			ry: 7.6,
			fill: "#4051BF"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			className: "dot",
			cx: 144.4,
			cy: 33.1996,
			rx: 7.60001,
			ry: 7.6,
			fill: "#4051BF"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			className: "dot",
			cx: 132.4,
			cy: 4.4,
			rx: 4.39999,
			ry: 4.4,
			fill: "#4051BF"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_dd_970_60785)",
			children: /* @__PURE__ */ _jsx("rect", {
				className: "rightBar",
				x: 28,
				y: 25,
				width: 96,
				height: 79,
				rx: 6,
				fill: "#D9DCF2"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_970_60785)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					className: "leftBar",
					x: 28,
					y: 24.8008,
					width: 96,
					height: 79.2,
					rx: 6,
					fill: "#9FA8DF"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "topLeftBar",
					d: "M28 30.8008C28 27.4871 30.6863 24.8008 34 24.8008H118C121.314 24.8008 124 27.4871 124 30.8008V38.4008H28V30.8008Z",
					fill: "#7985D2"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					className: "barDot",
					cx: 34,
					cy: 31.5996,
					rx: 2,
					ry: 2,
					fill: "#F3F3F7"
				}),
				/* @__PURE__ */ _jsx("circle", {
					className: "barDot",
					cx: 41.2,
					cy: 31.5996,
					r: 2,
					fill: "#F3F3F7"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					className: "barDot",
					cx: 48.3999,
					cy: 31.5996,
					rx: 2,
					ry: 2,
					fill: "#F3F3F7"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .4,
			clipPath: "url(#clip1_970_60785)",
			children: [/* @__PURE__ */ _jsx("g", {
				filter: "url(#filter1_dd_970_60785)",
				children: /* @__PURE__ */ _jsx("rect", {
					x: 28,
					y: 24.8008,
					width: 96,
					height: 79.2,
					rx: 6,
					fill: "#9FA8DF"
				})
			}), /* @__PURE__ */ _jsx("path", {
				className: "topRightBar",
				d: "M28 30.8008C28 27.4871 30.6863 24.8008 34 24.8008H118C121.314 24.8008 124 27.4871 124 30.8008V38.4008H28V30.8008Z",
				fill: "#7985D2"
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter2_b_970_60785)",
			children: [/* @__PURE__ */ _jsx("rect", {
				className: "searchCircle",
				x: 93,
				y: 44,
				width: 48,
				height: 48,
				rx: 24,
				fill: "#33395B"
			}), /* @__PURE__ */ _jsx("path", {
				className: "search",
				d: "M126 77L121.65 72.65M124 67C124 71.4183 120.418 75 116 75C111.582 75 108 71.4183 108 67C108 62.5817 111.582 59 116 59C120.418 59 124 62.5817 124 67Z",
				stroke: "#ADB2D1",
				strokeWidth: 4,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_dd_970_60785",
				x: 4,
				y: 21,
				width: 144,
				height: 127,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 8 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.04 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_970_60785"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 20 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 12 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_970_60785",
						result: "effect2_dropShadow_970_60785"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect2_dropShadow_970_60785",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_dd_970_60785",
				x: 4,
				y: 20.8008,
				width: 144,
				height: 127.199,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 8 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.04 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_970_60785"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 20 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 12 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_970_60785",
						result: "effect2_dropShadow_970_60785"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect2_dropShadow_970_60785",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_b_970_60785",
				x: 85,
				y: 36,
				width: 64,
				height: 64,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						in: "BackgroundImageFix",
						stdDeviation: 4
					}),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "SourceAlpha",
						operator: "in",
						result: "effect1_backgroundBlur_970_60785"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_backgroundBlur_970_60785",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_970_60785",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 36,
					height: 79,
					fill: "white",
					transform: "translate(28 25)"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip1_970_60785",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 60,
					height: 79,
					fill: "white",
					transform: "translate(64 25)"
				})
			})
		] })
	]
});
export default SvgNotFound;
